// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793429433397
      var cssReload = require("/root/code/tripairgo-admin/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  